import { IApplicationState } from '../types/redux';

export const selectSubdomainCityId = (state: IApplicationState): number => {
  return state.mainpage.regionsData.subdomainCityId;
};
